import Typography from "antd/lib/typography";
import clsx from "clsx";
import { MouseEventHandler } from "react";
import { useId } from "react-aria";

import { IUserResource } from "@sol/sdk";
import { Minus } from "@sol/uikit/core/icons/Minus";
import { Plus } from "@sol/uikit/core/icons/Plus";
import { Tooltip } from "@sol/uikit/data-display/Tooltip/Tooltip";
import { Button } from "@sol/uikit/general/Button/Button";

import { UserAvatar } from "./UserAvatar";
const MAP_ACTION_TYPE_TO_ICON = {
    add: <Plus size={16} />,
    remove: <Minus size={16} />,
};

type Props = {
    user: IUserResource;
    className?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    actionType?: "add" | "remove";
    disabledMessage?: string;
    display?: "row" | "block";
};

export const UserRow = ({
    user,
    onClick,
    className,
    disabledMessage,
    actionType = "add",
    display = "block",
}: Props) => {
    const usernameContainerId = useId();

    const iconButton = (
        <Button
            data-cy="user-row-button"
            onClick={onClick}
            disabled={!!disabledMessage}
            aria-describedby={usernameContainerId}
            icon={MAP_ACTION_TYPE_TO_ICON[actionType]}
            className="size-7!"
        />
    );

    return (
        <div data-cy="user-row" className={`flex h-20 items-center gap-4 rounded-xl bg-white p-5 ${className}`}>
            {disabledMessage ? (
                <Tooltip title={disabledMessage} color="red">
                    {iconButton}
                </Tooltip>
            ) : (
                iconButton
            )}
            <UserAvatar user={user} className="mr-4 shrink-0" />
            <div
                className={clsx(
                    "flex",
                    display === "block" && "flex-col",
                    display === "row" && "flex-1 justify-between",
                )}
            >
                <Typography.Text id={usernameContainerId} className="font-ant-strong">
                    <span>
                        {user.name} {user.surname?.toUpperCase()}
                    </span>
                </Typography.Text>
                <Typography.Text>{user.email}</Typography.Text>
            </div>
        </div>
    );
};
